import * as React from 'react'

/**
 * Renders text with line breaks in the content.
 */
export default function Text({ text }: { text: string | null | undefined }) {
  const lines = (text || '').split('\n')
  return (
    <>
      {lines.map((line, i) =>
        i === lines.length - 1 ? (
          line
        ) : (
          <React.Fragment key={i}>
            {line}
            <br />
          </React.Fragment>
        ),
      )}
    </>
  )
}
